"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = RightArrow;
var _react = _interopRequireDefault(require("react"));
function RightArrow(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className,
    width: "11",
    height: "17",
    viewBox: "0 0 11 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.485 0l8.486 8.485-8.486 8.486",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  }));
}